import { useMemo, useState } from 'react';
import { PageHero } from '../components/PageHero';
import { publicHooks } from '../data';
import { Link } from '../router';

export function ActivitiesPage() {
  const { data } = publicHooks.useActivities();
  const years = useMemo(() => [...new Set(data.map((activity) => activity.year))].sort((a, b) => b - a), [data]);
  const [selected, setSelected] = useState(years[0] ?? new Date().getFullYear());
  const activities = data.filter((activity) => activity.year === selected);

  return <>
    <PageHero eyebrow="Life at our school" title="Learning comes alive through community." intro="Activities give students room to create, move, celebrate, work as a team, and stay connected to the traditions that shape who they are." mark="03"/>
    <section className="gallery-section content-section">
      <div className="gallery-intro">
        <p className="section-kicker">Activity stories</p>
        <h2>Moments from Hsa Thoo Lei.</h2>
        <p>Explore the people, learning, and community behind each moment. Open a story to see the full activity and its social links.</p>
      </div>
      <nav className="activity-tabs-list" aria-label="Filter activities by year" role="tablist">
        {years.map((year) => <button type="button" className={`activity-year-button ${selected === year ? 'is-active' : ''}`} key={year} role="tab" aria-selected={selected === year} onClick={() => setSelected(year)}>{year}</button>)}
      </nav>
      <div className="activity-card-grid" aria-live="polite" role="tabpanel">
        {activities.map((activity, index) => <article className={`activity-card ${index === 0 ? 'is-featured' : ''}`} key={activity.id}>
          <Link className="activity-card-media" to={`/activities/${encodeURIComponent(activity.id)}`} aria-label={`Read ${activity.title}`}>
            <img src={activity.images[0].url} alt={activity.images[0].alt} width="1600" height="1067" loading={index === 0 ? 'eager' : 'lazy'}/>
          </Link>
          <div className="activity-card-copy">
            <p className="section-kicker">{activity.year} activity</p>
            <h3><Link to={`/activities/${encodeURIComponent(activity.id)}`}>{activity.title}</Link></h3>
            <p>{activity.description}</p>
            <div className="activity-card-footer">
              <span>{activity.images.length} {activity.images.length === 1 ? 'photo' : 'photos'}</span>
              <Link className="activity-read-more" to={`/activities/${encodeURIComponent(activity.id)}`}>Read more <span aria-hidden="true">→</span></Link>
            </div>
          </div>
        </article>)}
      </div>
    </section>
  </>;
}
